import React, {Component} from 'react';
import {Icon as BaseIcon} from 'react-icons-kit';
import {object, string, number, oneOfType, func} from 'prop-types';

class Icon extends Component {
  static propTypes = {
    className: string,
    size: oneOfType([number, string]),
    icon: object.isRequired,
    onClick: func,
  };
  static defaultProps = {
    className: '',
    onClick: ()=> undefined
  }

  render() {
    const {className, icon, size, onClick} = this.props;
    return ( // needs to override inline-block so that icon is centered within container
      <BaseIcon size={size} style={{display: 'inline-flex'}} className={className} icon={icon} onClick={onClick}/>
    );
  }
}


export default Icon;